import React from "react";
import OrderConfirmationDetails from "src/modules/OrderConfirmation/OrderConfirmationDetails";

type Props = {};

const OrderConfirmation = (props: Props) => {
  return (
    <div className="mb-[200px]">
      <OrderConfirmationDetails />
    </div>
  );
};

export default OrderConfirmation;
